import {NAV_FETCHED, ROUTE_FETCHED, FOOTER_FETCHED, CSRF_FETCHED, CTA_FETCHED} from "../types";
import api from "../api";

export const navFetched = nav => ({
    type: NAV_FETCHED,
    nav
});

export const csrfFetched = data => ({
    type: CSRF_FETCHED,
    data
});

export const ctaFetched = cta => ({
    type: CTA_FETCHED,
    cta
});

export const routeFetched = route => ({
    type: ROUTE_FETCHED,
    route
});

export const footerFetched = data => ({
    type: FOOTER_FETCHED,
    data
});


export const initApp = () => (dispatch, getState) =>{
    return api.init.fetchInit().then(res => {
        dispatch(navFetched(res.data[0].nav));
        dispatch(footerFetched(res.data[0].footer));
        dispatch(csrfFetched(res.data[0]));
        dispatch(ctaFetched(res.data[0].cta));
        return res.data[0].cta;
    });

}







// WEBPACK FOOTER //
// ./src/actions/init.js